module.exports = __webpack_public_path__ + "img/alert.a4af3760.svg";